export const dbPanels = {
  images: {
    subtitle: `Téléversez, réorganisez et définissez la photo principale de chaque unité affichée dans votre moteur de réservation.`,
  },

  amenities: {
    searchPlaceholder: `Rechercher un équipement…`,
    selectedCount: `{count} équipement sélectionné | {count} équipements sélectionnés`,
    noResults: `Aucun résultat pour « {query} ».`,
    // Fotos por comodidad: lo que el Agente IA le enseña al huésped.
    photos: {
      explain: `L'agent les montrera au client qui demande cet équipement.`,
      dropTitle: `Glissez vos photos ici`,
      addPhotos: `Ajouter des photos`,
      dropHint: `JPG, PNG, WebP ou HEIC · jusqu'à {mb} Mo chacune`,
      dropActive: `Déposez pour envoyer`,
      uploading: `Envoi… {progress} %`,
      uploaded: `{count} photo ajoutée | {count} photos ajoutées`,
      counter: `{count} photo | {count} photos`,
      remaining: `Vous pouvez ajouter {count} photo de plus | Vous pouvez ajouter {count} photos de plus`,
      full: `Le maximum de {max} photos est atteint`,
      tooMany: `Seulement {max} photos par équipement.`,
      tooHeavy: `« {name} » dépasse {mb} Mo. Réduisez-la avant de l'envoyer.`,
      notImage: `« {name} » n'est pas une image.`,
      uploadError: `Impossible d'envoyer les photos.`,
      removeAria: `Retirer cette photo`,
      deleteTitle: `Retirer cette photo ?`,
      deleteBody: `L'agent ne la montrera plus quand on demandera « {amenity} ». C'est irréversible.`,
      deleteCancel: `Annuler`,
      deleteConfirm: `Retirer la photo`,
      deleted: `Photo retirée`,
      deleteError: `Impossible de retirer la photo.`,
      // Orden: el agente solo manda las primeras, por eso se puede arrastrar.
      orderHint: `L'agent montre les {count} premières. Glissez par la poignée pour changer l'ordre.`,
      dragTitle: `Glissez pour réorganiser`,
      reordering: `Enregistrement de l'ordre…`,
      orderSaved: `Ordre enregistré`,
      orderError: `Impossible d'enregistrer l'ordre.`,
      willSend: `L'agent enverra cette photo`,
      wontSend: `L'agent n'ira pas jusqu'à cette photo`,
      someFailed: `Impossible de traiter : {names}`,
    },
  },

  occupancy: {
    question: `Quel ajustement souhaitez-vous appliquer ?`,
    questionRoom: `Quel ajustement souhaitez-vous appliquer à cette chambre ?`,
    modeNone: `Aucun`,
    modeReduction: `Réduction`,
    modeSurcharge: `Supplément`,
    baseOccupancy: `Occupation de base`,
    baseHint: `clients (le prix standard)`,
    thOccupancy: `Occupation`,
    thRule: `Règle`,
    thValue: `Valeur`,
    thActive: `Actif`,
    guestsCount: `{count} client | {count} clients`,
    ruleReductionPct: `Réduction %`,
    ruleReductionFixed: `Réduction {currency}`,
    reductionInfo: `Pour un nombre de clients inférieur à l'occupation de base, cette réduction s'applique au prix de l'hébergement.`,
    priceIncludes: `Le prix comprend`,
    guestsCapacity: `client (capacité de la chambre) | clients (capacité de la chambre)`,
    maxExtraGuests: `Clients supplémentaires max.`,
    chargePerExtraGuest: `Frais par client supplémentaire`,
    chargeFixed: `{currency} fixe`,
    perNight: `par nuit`,
    surchargeInfo: `Chaque client au-delà de la capacité incluse paie ces frais par nuit.`,
    noneRoom: `Cette chambre n'a aucun ajustement d'occupation : le même prix quel que soit le nombre de clients (dans la limite de la capacité).`,
    noneBooking: `Cette réservation n'a aucun ajustement d'occupation : le même prix quel que soit le nombre de clients (dans la limite de la capacité).`,
  },

  share: {
    title: `Partager (Hôtel)`,
    desc: `Ce lien est spécifique à cet hôtel. Partagez-le via WhatsApp ou ouvrez-le en tant que visiteur.`,
    linkLabel: `Lien de réservation de l'hôtel`,
    linkHint: `Utilisez-le dans votre bio, vos campagnes ou vos messages automatisés.`,
    viewAsVisitor: `Voir en tant que visiteur`,
    tip: `Astuce : vous pouvez envoyer ce lien avec votre message de confirmation de réservation.`,
    noLinkCopy: `Aucun lien à copier.`,
    copied: `Lien copié.`,
    copyError: `Impossible de copier le lien.`,
    noLinkShare: `Aucun lien à partager.`,
    whatsappMsg: `Bonjour 👋 Voici le lien pour réserver dans cet hôtel : {link}`,
    noLinkOpen: `Aucun lien à ouvrir.`,
  },

  unitServices: {
    title: `Équipements et commodités`,
    subPrefix: `Équipements pour`,
    thisRoom: `cette chambre`,
    subInfo: `Chaque type de chambre a les siens ; la réservation directe et l'Agent IA utilisent ceux de la chambre attribuée au client.`,
    loading: `Chargement des équipements…`,
    loadError: `Impossible de charger les équipements de cette chambre.`,
    retry: `Réessayer`,
    saving: `Enregistrement…`,
    saved: `Enregistré`,
    autosaveHint: `Les modifications sont enregistrées automatiquement au fur et à mesure que vous cochez ou décochez.`,
  },

  welcome: {
    tag: `Moteur de réservation directe`,
    titleA: `Obtenez des réservations`,
    titleHighlight: `sans commission`,
    sub: `Votre propre moteur de réservation par logement : partagez un lien, le client réserve et paie directement. Sans intermédiaires, sans commissions OTA.`,
    howItWorks: `Comment ça marche`,
    benefits: `Avantages`,
    step1Title: `Partagez votre lien`,
    step1Text: `Chaque logement a son propre lien. Publiez-le sur votre site web, vos réseaux sociaux ou WhatsApp ; l'agent IA l'envoie aussi aux prospects.`,
    step2Title: `Le client réserve`,
    step2Text: `Il choisit ses dates et paie dans votre moteur. La réservation arrive directement dans votre calendrier, sans commissions OTA.`,
    step3Title: `Vous êtes payé directement`,
    step3Text: `Recevez les paiements sans intermédiaires et ajoutez des promotions, des frais et des services supplémentaires à chaque séjour.`,
    ctaStart: `Commencer la configuration`,
    ctaPromotions: `Voir les promotions globales`,
    perk1Title: `Zéro commission OTA`,
    perk1Text: `Conservez 100 % de chaque réservation directe.`,
    perk2Title: `Paiement et confirmation instantanés`,
    perk2Text: `Le client paie et la réservation se confirme automatiquement.`,
    perk3Title: `Promotions et frais supplémentaires`,
    perk3Text: `Remises de séjour, services et vos propres frais.`,
    perk4Title: `Un lien par logement`,
    perk4Text: `Chaque annonce avec son propre moteur et sa propre disponibilité.`,
  },

  unitsList: {
    title: `Unités disponibles`,
    subtitle: `Activez les unités que vous souhaitez afficher dans votre moteur de réservation.`,
    loading: `Chargement…`,
    sectionUnits: `Unités`,
    colUnit: `Unité`,
    colCap: `Cap.`,
    colActive: `Actif`,
    noUnits: `Aucune unité configurée.`,
    active: `Actif`,
    inactive: `Inactif`,
    noticePrefix: `Activez les réservations directes depuis`,
    noticeGlobalConfig: `Paramètres généraux`,
    noticeSuffix: `pour gérer les unités.`,
    sectionLink: `Lien d'appartement individuel`,
    linkCardTitle: `Lien filtré pour cet appartement`,
    linkCardDesc: `Ouvre le même moteur de réservation général, mais en affichant cet appartement directement.`,
    viewAsVisitor: `Voir en tant que visiteur`,
    unitUpdated: `Unité mise à jour.`,
    updateError: `Impossible de mettre à jour.`,
    noLinkCopy: `Aucun lien à copier.`,
    linkCopied: `Lien copié.`,
    copyError: `Impossible de copier le lien.`,
    noLinkOpen: `Aucun lien à ouvrir.`,
  },

  commonAreaImages: {
    intro: `Photos générales (entrée, piscine, réception, jardin…) présentées au client comme couverture à l'ouverture du moteur, aux côtés de la galerie de chaque unité.`,
    imagesCount: `{count} image | {count} images`,
    reorderHint: `Glissez pour réorganiser · la principale sert de couverture`,
    reordering: `Réorganisation…`,
    dragTitle: `Glisser`,
    coverBadge: `Couverture`,
    empty: `Vous n'avez pas encore ajouté de photos des espaces communs. Téléversez-les ci-dessus pour créer la couverture de l'annonce.`,
    loadError: `Impossible de charger les photos des espaces communs.`,
    uploadSuccess: `Photos téléversées avec succès.`,
    uploadError: `Impossible de téléverser les images.`,
    orderUpdated: `Ordre mis à jour.`,
    orderError: `Impossible de mettre à jour l'ordre.`,
    deleteConfirmMsg: `Supprimer cette photo des espaces communs ?`,
    deleteConfirmHeader: `Supprimer l'image`,
    deleteAccept: `Supprimer`,
    deleteReject: `Annuler`,
    imageDeleted: `Image supprimée.`,
    deleteError: `Impossible de supprimer l'image.`,
    coverUpdated: `Couverture mise à jour.`,
    coverError: `Impossible de définir la couverture.`,
    invalidFiles: `Fichiers invalides : {message}\n{details}`,
  },
};
